import { call, getUsuarioId } from '../fundo_liquido/fundosService';
import { maskCnpj } from '../fundo_liquido/fields';
import { PrestadorForm, PrestadorListItem, PrestadorDetalhe, FundoVinculo, GrupoEconomico } from './types';

const nz = (s?: string): string | undefined => (s && s.trim() ? s.trim() : undefined);
const digitos = (s?: string): string | undefined => {
  const d = (s || '').replace(/\D/g, '');
  return d || undefined;
};
const dataBr = (x: unknown): string | undefined => {
  if (!x) return undefined;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(x));
  return m ? `${m[3]}/${m[2]}/${m[1]}` : String(x);
};

const mapPayload = (form: PrestadorForm) => ({
  cnpj: digitos(form.cnpj),
  nome: form.nome?.trim(),
  grupo_economico: nz(form.grupo_economico),
  grupo_economico_cnpj: digitos(form.grupo_economico_cnpj),
  is_anga: !!form.is_anga,
  papeis: form.papeis ?? [],
});

// --- grupo econômico ---
export async function listarGruposEconomicos(q?: string): Promise<GrupoEconomico[]> {
  const qs = q && q.trim() ? `?q=${encodeURIComponent(q.trim())}` : '';
  const data: any[] = (await call('GET', `/grupos-economicos${qs}`)) ?? [];
  return data.map((g) => ({ cnpj: String(g.cnpj ?? ''), nome: g.nome ?? '' }));
}

export async function cadastrarGrupoEconomico(cnpj: string, nome: string): Promise<GrupoEconomico> {
  const usuario_id = getUsuarioId();
  const data = await call('POST', '/grupos-economicos', {
    usuario_id,
    cnpj: (cnpj || '').replace(/\D/g, ''),
    nome: nome.trim(),
  });
  return { cnpj: String(data?.cnpj ?? ''), nome: data?.nome ?? nome.trim() };
}

export async function listarPrestadores(q?: string): Promise<PrestadorListItem[]> {
  const qs = q && q.trim() ? `?q=${encodeURIComponent(q.trim())}` : '';
  const data: any[] = (await call('GET', `/prestadores${qs}`)) ?? [];
  return data.map((r) => ({
    id: r.id,
    cnpj: r.cnpj ?? '',
    nome: r.nome ?? '',
    grupo_economico: r.grupo_economico_nome ?? r.grupo_economico ?? '',
    grupo_economico_cnpj: r.grupo_economico_cnpj ?? '',
    is_anga: !!r.is_anga,
    qtd_fundos: Number(r.qtd_fundos ?? 0),
  }));
}

export async function detalharPrestador(id: number | string): Promise<PrestadorDetalhe> {
  const d = await call('GET', `/prestadores?id=${encodeURIComponent(String(id))}`);
  const fundos: FundoVinculo[] = (d?.fundos ?? []).map((f: any) => ({
    id: f.id,
    fundo_id: f.fundo_id,
    papel: f.papel ?? '',
    data_inicio: dataBr(f.data_inicio),
    data_fim: dataBr(f.data_fim),
    razao_social: f.razao_social ?? '',
    nome_fantasia: f.nome_fantasia ?? undefined,
    fundo_cnpj: f.fundo_cnpj ?? '',
  }));
  return {
    id: d?.id,
    form: {
      cnpj: d?.cnpj ? maskCnpj(String(d.cnpj)) : undefined,
      nome: d?.nome ?? '',
      grupo_economico: d?.grupo_economico ?? undefined,
      grupo_economico_cnpj: d?.grupo_economico_cnpj ? maskCnpj(String(d.grupo_economico_cnpj)) : undefined,
      grupo_economico_nome: d?.grupo_economico_nome ?? undefined,
      is_anga: !!d?.is_anga,
      papeis: Array.isArray(d?.papeis) ? d.papeis.map(String) : [],
    },
    fundos,
  };
}

export async function cadastrarPrestador(form: PrestadorForm): Promise<{ prestador_id: number }> {
  const usuario_id = getUsuarioId();
  const data = await call('POST', '/prestadores', { usuario_id, ...mapPayload(form) });
  return { prestador_id: data?.prestador_id };
}

// ?id= no recurso /prestadores (o recurso path /prestadores/{id} não existe no gateway).
export async function atualizarPrestador(id: number | string, form: PrestadorForm): Promise<void> {
  const usuario_id = getUsuarioId();
  await call('PUT', `/prestadores?id=${id}`, { usuario_id, ...mapPayload(form) });
}

export async function removerPrestador(id: number | string): Promise<void> {
  const usuario_id = getUsuarioId();
  await call('DELETE', `/prestadores?id=${id}`, { usuario_id });
}
